import { AuthGuard } from './../shared/guards/auth.guard';

import { MceDropzoneComponent } from './../shared/components/tinymce/mce-dropzone/mce-dropzone.component';
import { MceBrowseComponent } from './../shared/components/tinymce/mce-browse/mce-browse.component';

export const mceUploadRoutes = {
    path: 'mce-upload',
    canActivate: [AuthGuard],
    component: MceDropzoneComponent
};

export const mceBrowseRoutes = {
    path: 'mce-browse',
    canActivate: [AuthGuard],
    component: MceBrowseComponent
};
